import { ROUTE_PATH, REGION_OPTIONS, STATE_OPTIONS, BRANCH_OPTIONS, BATCH_OPTIONS, CTC_OPTIONS, INDUSTRY_OPTIONS, YEAR_OPTIONS, SEMESTER_OPTIONS, TEMPLATE_OPTIONS } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmRadioModel, SmMetaSelectModel, SmDatepickerModel, SmMetaFileModel, SmBtnMetaModel, SmMetaTextAreaModel } from "common/models/utility-models/meta-model";
import moment from "moment";



export class StudentProfileMetaModel extends FormMetaModel {
  constructor() {
    super('Your Profile', '', ROUTE_PATH.studentDetails, 8);
  }

  override initProperties(): any {
    const formInfo = super.initProperties();
    // const addStudent=new SmMetaInputModel(
    //     'branchName',
    //     'branchName',
    //     'input',
    //     true,
    //     'form-control',
    //     1,
    //     1,
    //     'Branch Name',
    //     'text',
    //     '',
    //     false,
    //     true,
    //     true,
    //     false,
    //     100,
    //     1
    // );

    const first_name = new SmMetaInputModel(
      'first_name',
      'first_name',
      'input',
      true,
      'col-6 col-md-6',
      1,
      1,
      'First Name',
      'text',
      '',
      true,
      true,
      true,
      false,
      100,
      1
    );

    const last_name = new SmMetaInputModel(
      'last_name',
      'last_name',
      'input',
      true,
      'col-6 col-md-6',
      1,
      1,
      'Last Name',
      'text',
      '',
      true,
      true,
      true,
      false,
      100,
      1
    );

    const father_name = new SmMetaInputModel(
      'father_name',
      'father_name',
      'input',
      true,
      'col-6 col-md-6',
      1,
      1,
      "Father's Name",
      'text',
      '',
      true,
      true,
      true,
      false,
      100,
      1
    );

    const mother_name = new SmMetaInputModel(
      'mother_name',
      'mother_name',
      'input',
      true,
      'col-6 col-md-6',
      1,
      1,
      "Mother's Name",
      'text',
      '',
      true,
      true,
      true,
      false,
      100,
      1
    );

    const mobile_number = new SmMetaInputModel(
      'mobile_number',
      'mobile_number',
      'input',
      true,
      'col-6 col-md-6',
      1,
      1,
      'Mobile Number',
      'number',
      '',
      false,
      true,
      true,
      false,
      10,
      1
    );

    const parentMobileNumber = new SmMetaInputModel(
      'parentMobileNumber',
      'parentMobileNumber',
      'input',
      false,
      'col-6 col-md-6',
      1,
      1,
      "Parent's Mobile Number",
      'number',
      '',
      false,
      true,
      true,
      false,
      15,
      10,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      '',
      { evalKey: '', evalParam: [] },
      false,
      [],
      false,
      '',
      null,
      false,
      false,
      false,
      "Parent's Mobile Number"
    );

    const email = new SmMetaInputModel(
      'email',
      'email',
      'input',
      true,
      'input-fg form-group col-6 col-md-6',
      2,
      3,
      'Email Id',
      'text',
      '',
      true,
      true,
      true,
      false,
      100,
      5
    );

    const gender = new SmRadioModel(
      'gender',
      'gender',
      'radio',
      true,
      'col-xs-12 col-sm-12 col-md-4 col-lg-4 main-gender',
      1,
      2,
      'Gender',
      'checkbox',
      '',
      true,
      true,
      true,
      false,
      0,
      0,
      false,
      false,
      { evalKey: '', evalParam: [] },
      '',
      2,
      [
        {
          key: 'Male',
          value: ['off'],
          label: 'Male',
          decisiveKey: 'val',
          prop: { key: 'required', value: true },
        },
        {
          key: 'Female',
          value: ['off'],
          label: 'Female',
          decisiveKey: 'val',
          prop: { key: 'required', value: true },
        },
      ]
    );
    const address = new SmMetaInputModel(
      'address',
      'address',
      'input',
      true,
      'col-6 col-md-6',
      1,
      1,
      'Residence Address',
      'text',
      '',
      false,
      true,
      true,
      false,
      200,
      1
    );
    const age = new SmMetaInputModel(
      'age',
      'age',
      'input',
      true,
      'col-6 col-md-6',
      1,
      1,
      'Age',
      'number',
      '',
      true,
      true,
      true,
      false,
      2,
      1
    );
    const region_id = new SmMetaSelectModel(
      'region_id',
      'region_id',
      'ng-select',
      true,
      'col-12 col-md-4 mt-3',
      1,
      8,
      'Region',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      REGION_OPTIONS,
      'zone_name',
      'id',

    );
    const state_id = new SmMetaSelectModel(
      'state_id',
      'state_id',
      'select',
      true,
      'col-12',
      1,
      8,
      'State',
      'select',
      '',
      true,
      true,
      true,
      false,
      0,
      0,
      false,
      STATE_OPTIONS,
      'stateName',
      'id',
      false,
      false,
      false,
      false,
      false,
      false
    );

    const district_id = new SmMetaSelectModel(
      'district_id',
      'district_id',
      'select',
      true,
      'col-12 col-md-4 mt-3',
      1,
      1,
      'District',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      TEMPLATE_OPTIONS,
      'district',
      'id'
    );

    const name_of_college = new SmMetaInputModel(
      'name_of_college',
      'name_of_college',
      'input',
      true,
      'col-6 col-md-6',
      1,
      1,
      'College Name',
      'text',
      '',
      true,
      true,
      true,
      false,
      100,
      1
    );
    const college_address = new SmMetaInputModel(
      'college_address',
      'college_address',
      'input',
      true,
      'col-6 col-md-6',
      1,
      1,
      'College Address',
      'text',
      '',
      true,
      true,
      true,
      false,
      200,
      1
    );
    const branch_id = new SmMetaSelectModel(
      'branch_id',
      'branch_id',
      'select',
      false,
      'col-12',
      1,
      8,
      'Branch',
      'select',
      '',
      true,
      true,
      true,
      false,
      0,
      0,
      false,
      BRANCH_OPTIONS,
      'department_name',
      'id',
      false,
      false,
      false,
      false,
      false,
      false
    );
    const batch_id = new SmMetaSelectModel(
      'batch_id',
      'batch_id',
      'ng-select',
      false,
      'col-12',
      1,
      8,
      'Batch',
      'select',
      '',
      true,
      true,
      true,
      false,
      0,
      0,
      false,
      BATCH_OPTIONS,
      'batch_number',
      'id',
      false,
      false,
      false,
      false,
      false,
      false
    );
    const unique_batch_id = new SmMetaInputModel(
      'unique_batch_id',
      'unique_batch_id',
      'input',
      true,
      'col-6 col-md-6',
      1,
      1,
      'Unique ID',
      'text',
      '',
      true,
      true,
      true,
      false,
      100,
      1
    );
    const mentor_name = new SmMetaInputModel(
      'mentor_name',
      'mentor_name',
      'input',
      false,
      'col-6 col-md-6',
      1,
      1,
      'Mentor Name',
      'text',
      '',
      true,
      true,
      true,
      false,
      100,
      1
    );
    const mentor_email = new SmMetaInputModel(
      'mentor_email',
      'mentor_email',
      'input',
      false,
      'input-fg form-group col-6 col-md-6',
      2,
      3,
      'Mentor Email',
      'text',
      '[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}',
      true,
      true,
      true,
      false,
      100,
      5
    );
    const mentor_mobile = new SmMetaInputModel(
      'mentor_mobile',
      'mentor_mobile',
      'input',
      false,
      'col-6 col-md-6',
      1,
      1,
      'Mentor Mobile Number',
      'number',
      '',
      true,
      true,
      true,
      false,
      11,
      1
    );
    const summer_vacation_start_date = new SmDatepickerModel(
      'summer_vacation_start_date',
      'summer_vacation_start_date',
      'datepicker',
      false,
      'col-12 col-md-4',
      1,
      1,
      'Vacation Start Date',
      'text',
      '',
      false,
      true,
      true,
      false,
      false,
      'DD/MM/YYYY',
      '',
      [],
      false
    );
    const summer_vacation_end_date = new SmDatepickerModel(
      'summer_vacation_end_date',
      'summer_vacation_end_date',
      'datepicker',
      false,
      'col-12 col-md-4',
      1,
      1,
      'Vacation End Date',
      'text',
      '',
      false,
      true,
      true,
      false,
      false,
      'DD/MM/YYYY',
      '',
      [],
      false
    );
    const winter_vacation_start_date = new SmDatepickerModel(
      'winter_vacation_start_date',
      'winter_vacation_start_date',
      'datepicker',
      false,
      'col-12 col-md-4',
      1,
      1,
      'Vacation Start Date',
      'text',
      '',
      false,
      true,
      true,
      false,
      false,
      'DD/MM/YYYY',
      '',
      [],
      false
    );
    const winter_vacation_end_date = new SmDatepickerModel(
      'winter_vacation_end_date',
      'winter_vacation_end_date',
      'datepicker',
      false,
      'col-12 col-md-4',
      1,
      1,
      'Vacation End Date',
      'text',
      '',
      false,
      true,
      true,
      false,
      false,
      'DD/MM/YYYY',
      '',
      [],
      false
    );
    const first_year_score = new SmMetaInputModel(
      'first_year_score',
      'first_year_score',
      'input',
      false,
      'col-6 col-md-6',
      1,
      1,
      '',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const ktsem1 = new SmRadioModel(

      'ktsem1',
      'ktsem1',
      'radio',
      false,
      'col-xs-12 col-sm-12 col-md-4 col-lg-4 ',
      1,
      2,
      '',
      'checkbox',
      '',
      true,
      true,
      true,
      false,
      0,
      0,
      false,
      false,
      { evalKey: '', evalParam: [] },
      '',
      2,
      [
        {
          key: 1,
          value: ['off'],
          label: 'KT',
          decisiveKey: 'KT1',
          prop: { key: 'required', value: true }
        },
        {
          key: 0,
          value: ['off'],
          label: 'No KT',
          decisiveKey: 'NoKT1',
          prop: { key: 'required', value: true }
        }
      ]
    );
    const second_year_score = new SmMetaInputModel(
      'second_year_score',
      'second_year_score',
      'input',
      false,
      'col-6 col-md-6',
      1,
      1,
      '',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const ktsem2 = new SmRadioModel(

      'ktsem2',
      'ktsem2',
      'radio',
      false,
      'col-xs-12 col-sm-12 col-md-4 col-lg-4 ',
      1,
      2,
      '',
      'checkbox',
      '',
      true,
      true,
      true,
      false,
      0,
      0,
      false,
      false,
      { evalKey: '', evalParam: [] },
      '',
      2,
      [
        {
          key: 1,
          value: ['off'],
          label: 'KT',
          decisiveKey: 'KT2',
          prop: { key: 'required', value: true }
        },
        {
          key: 0,
          value: ['off'],
          label: 'No KT',
          decisiveKey: 'NoKT2',
          prop: { key: 'required', value: true }
        }
      ]
    );
    const third_year_score = new SmMetaInputModel(
      'third_year_score',
      'third_year_score',
      'input',
      false,
      'col-6 col-md-6',
      1,
      1,
      '',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const ktsem3 = new SmRadioModel(

      'ktsem3',
      'ktsem3',
      'radio',
      false,
      'col-xs-12 col-sm-12 col-md-4 col-lg-4 ',
      1,
      2,
      '',
      'checkbox',
      '',
      true,
      true,
      true,
      false,
      0,
      0,
      false,
      false,
      { evalKey: '', evalParam: [] },
      '',
      2,
      [
        {
          key: 1,
          value: ['off'],
          label: 'KT',
          decisiveKey: 'KT3',
          prop: { key: 'required', value: true }
        },
        {
          key: 0,
          value: ['off'],
          label: 'No KT',
          decisiveKey: 'NoKT3',
          prop: { key: 'required', value: true }
        }
      ]
    );
    const fourth_year_score = new SmMetaInputModel(
      'fourth_year_score',
      'fourth_year_score',
      'input',
      false,
      'col-6 col-md-6',
      1,
      1,
      '',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const ktsem4 = new SmRadioModel(

      'ktsem4',
      'ktsem4',
      'radio',
      false,
      'col-xs-12 col-sm-12 col-md-4 col-lg-4 ',
      1,
      2,
      '',
      'checkbox',
      '',
      true,
      true,
      true,
      false,
      0,
      0,
      false,
      false,
      { evalKey: '', evalParam: [] },
      '',
      2,
      [
        {
          key: 1,
          value: ['off'],
          label: 'KT',
          decisiveKey: 'KT4',
          prop: { key: 'required', value: true }
        },
        {
          key: 0,
          value: ['off'],
          label: 'No KT',
          decisiveKey: 'NoKT4',
          prop: { key: 'required', value: true }
        }
      ]
    );
    const first_year2_score = new SmMetaInputModel(
      'first_year2_score',
      'first_year2_score',
      'input',
      false,
      'col-6 col-md-6',
      1,
      1,
      '',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const ktsem5 = new SmRadioModel(

      'ktsem5',
      'ktsem5',
      'radio',
      false,
      'col-xs-12 col-sm-12 col-md-4 col-lg-4 ',
      1,
      2,
      '',
      'checkbox',
      '',
      true,
      true,
      true,
      false,
      0,
      0,
      false,
      false,
      { evalKey: '', evalParam: [] },
      '',
      2,
      [
        {
          key: 1,
          value: ['off'],
          label: 'KT',
          decisiveKey: 'KT5',
          prop: { key: 'required', value: true }
        },
        {
          key: 0,
          value: ['off'],
          label: 'No KT',
          decisiveKey: 'NoKT5',
          prop: { key: 'required', value: true }
        }
      ]
    );
    const second_year2_score = new SmMetaInputModel(
      'second_year2_score',
      'second_year2_score',
      'input',
      false,
      'col-6 col-md-6',
      1,
      1,
      '',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const ktsem6 = new SmRadioModel(

      'ktsem6',
      'ktsem6',
      'radio',
      false,
      'col-xs-12 col-sm-12 col-md-4 col-lg-4 ',
      1,
      2,
      '',
      'checkbox',
      '',
      true,
      true,
      true,
      false,
      0,
      0,
      false,
      false,
      { evalKey: '', evalParam: [] },
      '',
      2,
      [
        {
          key: 1,
          value: ['off'],
          label: 'KT',
          decisiveKey: 'KT6',
          prop: { key: 'required', value: true }
        },
        {
          key: 0,
          value: ['off'],
          label: 'No KT',
          decisiveKey: 'NoKT6',
          prop: { key: 'required', value: true }
        }
      ]
    );
    const third_year2_score = new SmMetaInputModel(
      'third_year2_score',
      'third_year2_score',
      'input',
      false,
      'col-6 col-md-6',
      1,
      1,
      '',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const ktsem7 = new SmRadioModel(

      'ktsem7',
      'ktsem7',
      'radio',
      false,
      'col-xs-12 col-sm-12 col-md-4 col-lg-4 ',
      1,
      2,
      '',
      'checkbox',
      '',
      true,
      true,
      true,
      false,
      0,
      0,
      false,
      false,
      { evalKey: '', evalParam: [] },
      '',
      2,
      [
        {
          key: 1,
          value: ['off'],
          label: 'KT',
          decisiveKey: 'KT7',
          prop: { key: 'required', value: true }
        },
        {
          key: 0,
          value: ['off'],
          label: 'No KT',
          decisiveKey: 'NoKT7',
          prop: { key: 'required', value: true }
        }
      ]
    );
    const fourth_year2_score = new SmMetaInputModel(
      'fourth_year2_score',
      'fourth_year2_score',
      'input',
      false,
      'col-6 col-md-6',
      1,
      1,
      '',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const ktsem8 = new SmRadioModel(

      'ktsem8',
      'ktsem8',
      'radio',
      false,
      'col-xs-12 col-sm-12 col-md-4 col-lg-4 ',
      1,
      2,
      '',
      'checkbox',
      '',
      true,
      true,
      true,
      false,
      0,
      0,
      false,
      false,
      { evalKey: '', evalParam: [] },
      '',
      2,
      [
        {
          key: 1,
          value: ['off'],
          label: 'KT',
          decisiveKey: 'KT8',
          prop: { key: 'required', value: true }
        },
        {
          key: 0,
          value: ['off'],
          label: 'No KT',
          decisiveKey: 'NoKT8',
          prop: { key: 'required', value: true }
        }
      ]
    );


    const profile_pic_path = new SmMetaFileModel(
      'profile_pic_path',
      'profile_pic_path',
      'file',
      false,
      'input-fg form-group col-lg-6 col-md-6',
      4,
      7,
      '',
      'singleimagepreview',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
      3000,
      250,
      510,
      'image',
      'profile_pic_path',
      false,
      false,
      2000,
      3000
    );

    // const studentAchievementDetails = new SmMetaDynamicFormModel(
    //   'studentAchievementDetails',
    //   'studentAchievementDetails',
    //   '',
    //   false,
    //   false,
    //   '',
    //   8,
    //   13,
    //   '',
    //   'addfirst',
    //   {
    const title = new SmMetaInputModel(
      'title',
      'title',
      'input',
      false,
      'col-12 col-md-6 col-lg-6',
      1,
      1,
      '',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      "",
      null,
      false,
      [],
      false,
      "",
      null,
      false,
      false,
      false,
      "Achievement Name"
    );
    const fileOriginalName = new SmMetaFileModel(
      'fileOriginalName',
      'fileOriginalName',
      'file',
      false,
      'col-12 col-lg-6 col-md-6',
      4,
      7,
      '',
      'singleimagepreview',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      ['pdf'],
      3000,
      250,
      510,
      'image',
      'fileOriginalName',
      false,
      false,
      2000,
      3000
    );
    //   },
    //   5,
    //   true,
    //   true,
    //   true,
    //   true,
    //   [],
    //   32,
    //   true,
    //   { evalKey: 'studentachievement', evalParam: ['CORP_USER'] }
    // );
    const placement_company_name = new SmMetaInputModel(
      'placement_company_name',
      'placement_company_name',
      'input',
      false,
      'col-12 col-md-3',
      1,
      1,
      'Company Name',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const placement_company_location = new SmMetaInputModel(
      'placement_company_location',
      'placement_company_location',
      'input',
      false,
      'col-12 col-md-3',
      1,
      1,
      'Company Location',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const placement_company_designation = new SmMetaInputModel(
      'placement_company_designation',
      'placement_company_designation',
      'input',
      false,
      'col-12 col-md-3',
      1,
      1,
      'Company Designation',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const placement_company_package = new SmMetaSelectModel(
      'placement_company_package',
      'placement_company_package',
      'select',
      false,
      'col-12 col-md-4',
      1,
      8,
      'CTC Offered',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      CTC_OPTIONS,
      'title',
      'title',
      false,
      false,
      false,
      false,
      false,
      false
    );
    const placement_company_type = new SmMetaSelectModel(
      'placement_company_type',
      'placement_company_type',
      'select',
      false,
      'col-12',
      1,
      8,
      'Industry Type',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      INDUSTRY_OPTIONS,
      'name',
      'name',
      false,
      false,
      false,
      false,
      false,
      false
    );
    const first_year_credit = new SmMetaInputModel(
      'first_year_credit',
      'first_year_credit',
      'input',
      false,
      'col-6 col-md-6',
      1,
      1,
      '',
      'text',
      '',
      true,
      true,
      true,
      false,
      100,
      1
    );
    const second_year_credit = new SmMetaInputModel(
      'second_year_credit',
      'second_year_credit',
      'input',
      false,
      'col-6 col-md-6',
      1,
      1,
      '',
      'text',
      '',
      true,
      true,
      true,
      false,
      100,
      1
    );
    const third_year_credit = new SmMetaInputModel(
      'third_year_credit',
      'third_year_credit',
      'input',
      false,
      'col-6 col-md-6',
      1,
      1,
      '',
      'text',
      '',
      true,
      true,
      true,
      false,
      100,
      1
    );
    const fourth_year_credit = new SmMetaInputModel(
      'fourth_year_credit',
      'fourth_year_credit',
      'input',
      false,
      'col-6 col-md-6',
      1,
      1,
      '',
      'text',
      '',
      true,
      true,
      true,
      false,
      100,
      1
    );
    const year = new SmMetaSelectModel(
      'year',
      'year',
      'select',
      true,
      'col-12 col-md-6',
      1,
      2,
      '',
      'number',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      YEAR_OPTIONS,
      'name',
      'id',
      false,
      false,
      false,
      false,
      false,
      false
    );

    const uploadedFileOriginalName = new SmMetaFileModel(
      'uploadedFileOriginalName',
      'uploadedFileOriginalName',
      'file',
      false,
      'input-fg form-group col-12 col-md-12',
      4,
      7,
      '',
      'multitypeimagepreview',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml', 'image/webp'],
      3000,
      250,
      510,
      'pdf',
      'uploadedFileOriginalName',
      false,
      false,
      2000,
      3000
    );

    const semester = new SmMetaSelectModel(
      'semester',
      'semester',
      'select',
      false,
      'col-12',
      1,
      8,
      '',
      '',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      SEMESTER_OPTIONS,
      'name',
      'id',
      false,
      false,
      false,
      false,
      false,
      false
    );

    const fee_receipt = new SmMetaFileModel(
      'fee_receipt',
      'fee_receipt',
      'file',
      false,
      'input-fg form-group col-6 col-md-6',
      4,
      7,
      '',
      'singleimagepreview',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
      3000,
      250,
      510,
      'image',
      'filePath',
      false,
      false,
      2000,
      3000
    );

    const other = new SmMetaTextAreaModel(
      'other',
      'other',
      'SimpleTextarea',
      false,
      'col-12 ',
      1,
      2,
      'Other Information (Working on a start up, working with any company,further study details, etc)',
      'textarea',
      '',
      false,
      true,
      true,
      false,
      100,
      0,
      false,
      false
  );
    const annual_year_selection: boolean = true;
    const semi_annual_sem_selection: boolean = false;
    // const batch_duration_start: string = '';
    const currentYear: string = moment().format('YYYY');
    const studentDocumentDetailYearlyFirst: any = [];
 const consent:any = ""
    // const fileName: any = [];
    // const pageSize: any = [];
    // const uniqueId: string = '';
    // const batchs: any = [];
    // const batchEndyear: any = [];
    // const selectedBatchNumber: any = '';
    // const today: Date = new Date();
    // const totalDuration: any = [];
    // const semesterCount: any = [];
    // const batch_number: any = [];
    // const duration_start: any = [];
    // const duration_end: any = [];
    // const fileOriginalName: any = [];

    const postAnnualData: any = {};
    const postSubAnnual: any = {};
    const allUploadDocs:any=[]
    const buttons = {
      submit: new SmBtnMetaModel('Save', '', true, false, true, true),
      isFormControl: false,
    };
    // const save = new SmBtnMetaModel(
    //   'Save',
    //   'primary',
    //   true,
    //   false,
    //   true,
    //   false
    // );

    return {
      formInfo,
      buttons,
      first_name,
      last_name,
      father_name,
      mother_name,
      mobile_number,
      email,
      gender,
      address,
      district_id,
      annual_year_selection,
      semi_annual_sem_selection,
      // batch_duration_start,
      currentYear,
      studentDocumentDetailYearlyFirst,

      // fileName,
      // pageSize,
      // uniqueId,
      //studentAchievementDetails,
      region_id,
      state_id,
      name_of_college,
      college_address,
      branch_id,
      // batch,
      unique_batch_id,
      mentor_name,
      mentor_email,
      mentor_mobile,
      parentMobileNumber,
      summer_vacation_start_date,
      summer_vacation_end_date,
      winter_vacation_start_date,
      winter_vacation_end_date,
      // batchs,
      // batchEndyear,
      // selectedBatchNumber,
      // today,
      // totalDuration,
      // semesterCount,
      batch_id,
      // duration_start,
      // duration_end,
      first_year_score,
      second_year_score,
      third_year_score,
      fourth_year_score,
      first_year2_score,
      second_year2_score,
      third_year2_score,
      fourth_year2_score,
      ktsem1,
      ktsem2,
      ktsem3,
      ktsem4,
      ktsem5,
      ktsem6,
      ktsem7,
      ktsem8,
      placement_company_name,
      placement_company_location,
      placement_company_designation,
      placement_company_package,
      placement_company_type,
      first_year_credit,
      second_year_credit,
      third_year_credit,
      fourth_year_credit,
      year,
      age,
      uploadedFileOriginalName,
      semester,
      title,
      fee_receipt,
      fileOriginalName,
      profile_pic_path,
      postAnnualData,
      postSubAnnual,
      // addStudent,
      other,
      consent,
      allUploadDocs
    };
  }
}